import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";

const DoctorInbox = () => {
    const [userdata, setUserdata] = useState({});

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        console.log("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    return (
        <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
            {userdata.activation_key == null && (
                <EmailVerify />
            )}

            <section className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <section className="dc-haslayout am-chat-module">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-10">
                            <div className="dc-dashboardbox dc-messages-holder">
                                <div className="dc-dashboardboxtitle">
                                    <h2>Messages</h2>
                                </div>
                                <div className="dc-dashboardboxtitle dc-titlemessages chat-current-user"></div>
                                <div className="dc-dashboardboxcontent dc-dashboardholder dc-offersmessages">
                                    <ul>
                                        <li>
                                            <div className="dc-formtheme dc-formsearch">
                                                <fieldset>
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            autoComplete="off"
                                                            name="fullname"
                                                            className="form-control dc-filter-users"
                                                            placeholder="Search Users"
                                                        />
                                                        <a href="javascript:void(0)" className="dc-searchgbtn">
                                                            <i className="fa fa-filter"></i>
                                                        </a>
                                                    </div>
                                                </fieldset>
                                            </div>
                                            <div className="dc-verticalscrollbar dc-dashboardscrollbar lore mCustomScrollbar _mCS_2 mCS_no_scrollbar">
                                                <div id="mCSB_2" className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside" style={{ maxHeight: 'none' }} tabIndex="0">
                                                    <div id="mCSB_2_container" className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" style={{ position: 'relative', top: 0, left: 0 }} dir="ltr">
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="dc-chatarea load-dc-chat-message">
                                                <div className="dc-chatarea dc-chatarea-empty">
                                                    <figure className="dc-chatemptyimg">
                                                        <img
                                                            src="//css.meddylist.com//wp-content/themes/doctreat/images/message-img.png"
                                                            alt="No Message Selected"
                                                        />
                                                        <figcaption>
                                                            <h3>No message selected to display</h3>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    );
};

export default DoctorInbox;
